<template>
    <div>
        <div class="bigTitleBox">
            <span class="bigTitle">商业能力</span>
            <div class="searchForm">
                <span>数据范围：</span>
                <el-select v-model="range" size="small" @change="() => onSearch(range, 'range')">
                    <template #default>
                        <el-option label="近30天" :value="30"></el-option>
                        <el-option label="近90天" :value="90"></el-option>
                    </template>
                </el-select>
            </div>
        </div>
        <div class="panel-wrap">
            <div class="panel-box">
                <div class="title-bar">
                    <span class="title">传播价值</span>
                    <el-divider direction="vertical"></el-divider>
                    <el-tag v-for="item in typeArr" :key="item.label" size="mini"
                        :effect="type == item.value ? 'dark' : 'light'"
                        @click="() => { type = item.value; onSearch(item.value, 'type') }" class="tag-option">
                        {{ item.label }}
                    </el-tag>
                    <span v-if="type == 2">
                        <el-checkbox v-model="onlyAssign" :true-label="1" :false-label="0"
                            @change="() => onSearch(onlyAssign, 'onlyAssign')">只看指派</el-checkbox>
                    </span>
                    <span v-if="type == 2">
                        <el-tooltip effect="dark" content="关联投放账户可排除营销流量" placement="top-start">
                            <el-checkbox v-model="flowType" :true-label="1" :false-label="0"
                                @change="() => onSearch(flowType, 'flowType')"><span
                                    class="underline-container">排除营销流量</span></el-checkbox>
                        </el-tooltip>
                    </span>
                </div>
                <div class="content-grid">
                    <div v-for="item in panelArr1" :key="item.label" class="info-item">
                        <div class="label">
                            <el-tooltip class="item" effect="dark" :disabled="!item.labelTips" :content="item.labelTips"
                                placement="top-start">
                                <div :class="{ 'underline-container': !!item.labelTips }">{{ item.label }}</div>
                            </el-tooltip>
                        </div>
                        <div class="value">{{ item.value }}</div>
                        <div class="bottom-info" v-html="item.bottomHtml"></div>
                    </div>
                </div>
            </div>
            <div class="panel-box">
                <div class="title-bar">
                    <span class="title">
                        种草价值
                        <el-tooltip effect="dark" content="仅统计星图商单数据" placement="top">
                            <i class="vxe-cell-help-icon vxe-icon-question-circle-fill"></i>
                        </el-tooltip>
                    </span>
                </div>
                <div class="content-grid">
                    <div v-for="item in panelArr2" :key="item.label" class="info-item">
                        <div class="label">
                            <el-tooltip class="item" effect="dark" :disabled="!item.labelTips" :content="item.labelTips"
                                placement="top-start">
                                <div :class="{ 'underline-container': !!item.labelTips }">{{ item.label }}</div>
                            </el-tooltip>
                        </div>
                        <div class="value">{{ item.value }}</div>
                        <div class="bottom-info" v-html="item.bottomHtml"></div>
                    </div>
                </div>
            </div>
            <div class="panel-box" style="grid-column: 1/3;">
                <div class="title-bar">
                    <span class="title">转化价值</span>
                    <el-tooltip effect="dark" content="仅统计绑定了组件的星图商单数据" placement="top">
                        <i class="vxe-cell-help-icon vxe-icon-question-circle-fill"></i>
                    </el-tooltip>
                </div>
                <div class="content-grid" style="grid-template-columns: repeat(3, 1fr);">
                    <div v-for="item in panelArr3" :key="item.label" class="info-item">
                        <div class="label">
                            <el-tooltip class="item" effect="dark" :disabled="!item.labelTips" :content="item.labelTips"
                                placement="top-start">
                                <div :class="{ 'underline-container': !!item.labelTips }">{{ item.label }}</div>
                            </el-tooltip>
                        </div>
                        <div class="value">{{ item.value }}</div>
                        <div class="bottom-info" v-html="item.bottomHtml"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        darenID: { type: String, default: '' },
    },
    data() {
        return {
            range: 30, //数据范围
            type: 1, //1为个人视频 2 星图视频 默认1
            onlyAssign: 0,//仅展示指派视频1-开 0-关，默认0
            flowType: 0, //排除营销流量1-开 0-关，默认0
            typeArr: [{ label: '个人视频', value: 1 }, { label: '星图视频', value: 2 }],
            panelArr1: [
                {
                    label: '播放量中位数',
                    labelTips: '所选数据范围内视频播放量中位数（仅统计公开可见视频）',
                    value: '-',
                    bottomHtml: '优于-%同类型达人'
                },
                {
                    label: '预期CPM',
                    labelTips: '根据达人最新报价及视频近期预估播放量计算，不跟随数据范围/个人视频/星图视频/是否指派变化',
                    value: '-',
                    bottomHtml: null
                },
                {
                    label: '完播率',
                    labelTips: '所选数据范围内视频平均完播率（仅统计公开可见视频）',
                    value: '-',
                    bottomHtml: '2'
                },
                {
                    label: '互动率',
                    labelTips: '所选数据范围内视频平均互动率（仅统计公开可见视频）',
                    value: '-',
                    bottomHtml: '优于-%同类型达人'
                }
            ],
            panelArr2: [
                {
                    label: '商单视频看后搜率',
                    labelTips: '达人星图视频所带来的看后搜次数/达人星图视频所带来的播放次数',
                    value: '-',
                    bottomHtml: '优于-%同类型达人'
                },
                {
                    label: '个人视频看后搜率',
                    labelTips: '达人个人视频所带来的有商业价值的看后搜次数/达人星图视频所带来的播放次数',
                    value: '-',
                    bottomHtml: '优于-%同类型达人'
                },
                {
                    label: 'A3增长数',
                    labelTips: '达人星图商单所带来的A3人数',
                    value: '-',
                    bottomHtml: '2'
                },
                {
                    label: '进店成本',
                    labelTips: '近30天无星立方订单',
                    value: '-',
                    bottomHtml: null
                }
            ],
            panelArr3: [
                {
                    label: '相关视频数',
                    labelTips: '绑定了组件的星图视频数量（如购物车组件、落地页组件等）',
                    value: '-',
                    bottomHtml: null
                },
                {
                    label: '组件点击率',
                    labelTips: '绑定了组件的星图视频组件点击量/组件展示量',
                    value: '-',
                    bottomHtml: null
                },
                {
                    label: 'CPC',
                    labelTips: '绑定了组件的星图商单金额/相关视频点击数',
                    value: '-',
                    bottomHtml: null
                },
            ],
        }
    },
    methods: {
        onSearch(value, field) {
            // console.log('arguments :>> ', arguments);
            if (field == 'type' && value == 1) {
                this.onlyAssign = 0
                this.flowType = 0
            }
            if (['range', 'type', 'onlyAssign', 'flowType'].includes(field)) {
                this.fetchSpread()
            }
            if(field == 'range'){
                this.fetchAggregator()
                this.fetchConvertability()
            }
        },
        async fetchSpread() {

            let params = {
                id: this.darenID,
                range: this.range == 30 ? 2 : this.range == 90 ? 3 : null,
                type: this.type,
                only_assign: this.onlyAssign,
                flow_type: this.flowType
            }
            let spreadCpm = null // 预期CPM
            const aggParams = {
                o_author_id: this.darenID,
                range: this.range,
                route: 'get_author_commerce_spread_info'
            }
            const aggRes = await this.$axios.get(`/author-aggregator`, { params: aggParams })
            if (aggRes?.data?.code === 0) {
                const cpm = this.flowType == 1 ? aggRes.data?.data?.sn_cpm_20_60 : aggRes.data?.data?.cpm_20_60
                spreadCpm = (+(+cpm || 0)?.toFixed?.(1)) || null
            }
            const res = await this.$axios.get(`/author-spread/${this.darenID}`, { params })
            if (res?.data?.code === 0) {
                const data = res.data.data
                console.log('resData :>> ', data);
                this.panelArr1.forEach(item => {
                    if(item.label == '播放量中位数'){
                        let value  = data.item_rate.play_mid.value > 10000 ? `${(data.item_rate.play_mid.value / 10000).toFixed(1)}w` : data.item_rate.play_mid.value
                        item.value = value || '-'
                        item.bottomHtml = `优于${data.item_rate.play_mid.overtake ? (data.item_rate.play_mid.overtake / 100)?.toFixed(2) : '-'}%同类型达人`
                    } else if(item.label == '预期CPM'){
                        item.value = spreadCpm || '-'
                    } else if(item.label == '完播率'){
                        item.value = `${ data.play_over_rate.value ? (data.play_over_rate.value / 100)?.toFixed(1) : '-'}%`
                        item.bottomHtml = `优于${data.play_over_rate.overtake ? (data.play_over_rate.overtake / 100)?.toFixed(2) : '-'}%同类型达人`
                    } else if(item.label == '互动率'){
                        item.value = `${data.interact_rate.value ? (data.interact_rate.value / 100)?.toFixed(1) : '-'}%`
                        item.bottomHtml = `优于${data.interact_rate.overtake ? (data.interact_rate.overtake / 100)?.toFixed(2) : '-'}%同类型达人`
                    }
                })

            }
        },
        async fetchAggregator() {
            let params = {
                o_author_id: this.darenID,
                range: this.range,
                route: 'get_author_commerce_seed_base_info'
            }
            const res = await this.$axios.get(`/author-aggregator`, { params })
            if (res?.data?.code === 0) {
                const data = res.data.data
                console.log('resData :>> ', data);
                this.panelArr2.forEach(item => {
                    if(item.label == '商单视频看后搜率'){
                        item.value = data.avg_search_after_view_rate || '-'
                        item.bottomHtml = `优于${(data.avg_search_after_view_rate_rank_percent * 100) || '-'}%同类型达人`
                    } else if(item.label == '个人视频看后搜率'){
                        item.value = data.personal_avg_search_after_view_rate || '-'
                        item.bottomHtml = `优于${(data.personal_avg_search_after_view_rate_rank_percent * 100) || '-'}%同类型达人`
                    } else if(item.label == 'A3增长数'){
                        item.value = data.avg_a3_incr_cnt
                        item.bottomHtml = `优于${(data.avg_a3_incr_cnt_rank_percent * 100) || '-'}%同类型达人`
                    } else if(item.label == '进店成本'){
                        item.value = `-`
                        item.bottomHtml = `-`
                    }
                })

            }
        },
        async fetchConvertability() {
            let params = {
                id: this.darenID,
                range: this.range == 30 ? 2 : this.range == 90 ? 3 : null,
                platform_channel: 1
            }
            const res = await this.$axios.get(`/author-convertability/${this.darenID}`, { params })
            if (res?.data?.code === 0) {
                const data = res.data.data
                // console.log('resData :>> ', data);
                this.panelArr3.forEach(item => {
                    if(item.label == '相关视频数'){
                        item.value = data.related_video_cnt.value || '-'
                    } else if(item.label == '组件点击率'){
                        item.value = data.component_click_rate_range || '-'
                    } else if(item.label == 'CPC'){
                        item.value = data.related_cpc_range
                    }
                })

            }
        },
    },
    mounted() {
        this.fetchSpread()
        this.fetchAggregator()
        this.fetchConvertability()
    },
};
</script>
<style lang='scss' scoped>
.bigTitleBox {
    box-sizing: border-box;
    padding: 24px 0;
    border-bottom: 1px solid #F0F0F0;
    margin-bottom: 24px;


    .bigTitle {
        font-size: 16px;
        /* font-weight: 600; */
        line-height: 22px;
    }

    display: flex;
    justify-content: space-between;
    align-items: center;

    .searchForm {
        font-size: 14px;
    }
}

.panel-wrap {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    .panel-box {
        padding: 16px;
        border: 1px solid #f2f3f5;
        border-radius: 12px;
        box-sizing: border-box;

        .title-bar {
            display: flex;
            align-items: center;
            gap: 8px;

            .title {
                font-size: 14px;
                line-height: 22px;
                text-underline-offset: 2px;
            }
        }

        .content-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);

            .info-item {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;

                .label {
                    color: #666;
                    font-family: PingFang SC;
                    font-weight: 600;
                    font-size: 12px;
                    line-height: 18px;
                }

                .value {
                    color: #31343B;
                    font-weight: 700;
                    font-size: 18px;
                }

                .bottom-info {
                    color: #93969D;
                    font-size: 12px;
                    line-height: 18px;
                    text-underline-offset: 2px;
                }
            }
        }
    }
}

.underline-container {
    text-underline-position: under;
    text-underline-offset: 2px;
    text-decoration: underline dashed;

    /* 设置颜色 */

}

.tag-option {
    cursor: pointer;
    margin-right: 4px;
}
</style>